import { forwardRef, useImperativeHandle, useRef } from "react";
import PropTypes from "prop-types";
import { FoodItems } from "./FoodItems";
import { EmptyFood } from "../empty-states/EmptyFood";

export const FoodDisplay = forwardRef(
  ({ items, location, onRemoveItem, onUpdateItems, state, setState }, ref) => {
    const { saveAsNewMeal, mealName, mealDescription } = state;
    const mealNameInputRef = useRef(null);

    //Send the method to the parent component
    useImperativeHandle(ref, () => ({
      focusMealName: () => {
        mealNameInputRef.current?.focus();
        mealNameInputRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      },
    }));

    /**
     * Handle the name and description of the meal
     * @param {*} e
     */
    const handleMealInputChange = (e) => {
      const { name, value } = e.target;

      setState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    return (
      <div className="display-food">
        {items.length > 0 ? (
          <>
            <FoodItems
              items={items}
              onRemoveItem={onRemoveItem}
              onUpdateItems={onUpdateItems}
            />
            {saveAsNewMeal && (
              <div className="save-new-meal">
                <div className="meal-name-container">
                  <label className="label" htmlFor="mealName">
                    Meal Name
                  </label>
                  <input
                    ref={mealNameInputRef}
                    maxLength={100}
                    type="text"
                    placeholder={`Enter meal name`}
                    name="mealName"
                    value={mealName}
                    onChange={handleMealInputChange}
                  />
                </div>
                <div>
                  <label className="label" htmlFor="mealDescription">
                    Meal Description
                  </label>
                  <input
                    type="text"
                    name="mealDescription"
                    placeholder="Enter description here"
                    value={mealDescription}
                    onChange={handleMealInputChange}
                    maxLength={100}
                  ></input>
                </div>
              </div>
            )}
          </>
        ) : (
          <EmptyFood label={location} variant="added" />
        )}
      </div>
    );
  }
);

FoodDisplay.propTypes = {
  items: PropTypes.array,
  location: PropTypes.string,
  onRemoveItem: PropTypes.func,
  onUpdateItems: PropTypes.func,
  state: PropTypes.object,
  setState: PropTypes.func,
};
